import { customFetch } from '#/services/customFetch'

export interface CreateContactParams {
  name: string
  email: string
  phone?: string
  subject?: string
  message: string
}

export interface CreateContactResponse {
  id: string
  message: string
}

export async function createContact(
  body: CreateContactParams,
): Promise<CreateContactResponse> {
  return customFetch<CreateContactResponse>('/student/contact', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}
